import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { CoreActions } from '../stores/actions/core.actions';
import { AuthService } from '../auth.service';
import { UserActions } from '../stores/actions/user.actions';

@Injectable()
export class AuthGuard implements CanActivate {
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);
  private readonly _store = inject(Store);
  
  canActivate(activatedRoute: ActivatedRouteSnapshot) {
    //get the jwt token which are present in the local storage
    const token = localStorage.getItem("token");
    //Check if the token is expired or not and if token is expired then redirect to login page and return false
    if (token && this._authService.checkTokenExpiry(token)) {
      return true;
    }
    this._store.dispatch(CoreActions.setRedirectURL({ redirectUrl: activatedRoute.url.join('/')}))
    this._router.navigate(["login"]);
    return false;
  }
}